export interface UseCase {
  slug: string
  key: string
  category: 'educators' | 'experts'
  metaTitle: string
  metaDescription: string
  keywords: string[]
}

export const USE_CASES: UseCase[] = [
  // Educators
  {
    slug: 'new-creators',
    key: 'newCreators',
    category: 'educators',
    metaTitle: 'Edugram for New Creators - Start Your Educational Journey',
    metaDescription:
      'Launch your educational content business with Edugram. Perfect for new creators looking to share knowledge, build an audience, and monetize their expertise from day one.',
    keywords: [
      'new content creator',
      'start teaching online',
      'beginner course creator',
      'first online course',
      'educational content creator',
      'new educator platform',
    ],
  },
  {
    slug: 'established-creators',
    key: 'establishedCreators',
    category: 'educators',
    metaTitle: 'Edugram for Established Creators - Scale Your Education Business',
    metaDescription:
      'Take your educational business to the next level with Edugram. Advanced tools for established creators to scale, automate, and maximize revenue from courses and content.',
    keywords: [
      'established creator',
      'scale online courses',
      'grow education business',
      'advanced course platform',
      'professional educator tools',
      'course business growth',
    ],
  },
  {
    slug: 'educational-vloggers',
    key: 'educationalVloggers',
    category: 'educators',
    metaTitle: 'Edugram for Educational Vloggers - Monetize Your Video Content',
    metaDescription:
      'Turn your educational vlogs into a profitable business. Create courses from your videos, build a community, and earn from your educational video content on Edugram.',
    keywords: [
      'educational vlogger',
      'youtube education',
      'video course creator',
      'educational video content',
      'vlog monetization',
      'educational youtuber',
    ],
  },
  {
    slug: 'teachers-professors',
    key: 'teachersProfessors',
    category: 'educators',
    metaTitle: 'Edugram for Teachers & Professors - Extend Your Classroom Online',
    metaDescription:
      'Bring your teaching expertise online with Edugram. Purpose-built for teachers and professors to create courses, share resources, and reach students beyond the classroom.',
    keywords: [
      'teachers online platform',
      'professors online courses',
      'academic teaching online',
      'teacher course platform',
      'university professors online',
      'educational institution',
    ],
  },
  {
    slug: 'mentors',
    key: 'mentors',
    category: 'educators',
    metaTitle: 'Edugram for Mentors - Share Your Wisdom & Build Your Practice',
    metaDescription:
      'Create a thriving mentorship business on Edugram. Offer courses, programs, and subscriptions to share your expertise and guide others to success.',
    keywords: [
      'online mentorship',
      'mentor platform',
      'mentoring business',
      'coaching and mentoring',
      'professional mentor',
      'mentorship programs',
    ],
  },
  // Other Experts
  {
    slug: 'vloggers-bloggers',
    key: 'vloggersBloggers',
    category: 'experts',
    metaTitle: 'Edugram for Vloggers & Bloggers - Monetize Your Content',
    metaDescription:
      'Transform your vlog or blog into a revenue stream with Edugram. Create courses, subscriptions, and premium content from your existing audience.',
    keywords: [
      'vlogger monetization',
      'blogger income',
      'content creator platform',
      'vlog courses',
      'blog monetization',
      'creator economy',
    ],
  },
  {
    slug: 'streamers',
    key: 'streamers',
    category: 'experts',
    metaTitle: 'Edugram for Streamers - Build Courses From Your Streams',
    metaDescription:
      'Turn your streaming expertise into structured courses. Edugram helps streamers create educational content, build communities, and earn beyond donations and subscriptions.',
    keywords: [
      'streamer education',
      'twitch courses',
      'streaming tutorials',
      'gaming courses',
      'streamer monetization',
      'content creator courses',
    ],
  },
  {
    slug: 'content-makers',
    key: 'contentMakers',
    category: 'experts',
    metaTitle: 'Edugram for Content Makers - Package Your Knowledge',
    metaDescription:
      'Content makers, turn your creative expertise into profitable courses. Share your techniques, build your brand, and create sustainable income on Edugram.',
    keywords: [
      'content creator',
      'creative courses',
      'content creation education',
      'digital creator platform',
      'creative monetization',
      'maker education',
    ],
  },
  {
    slug: 'experts-field',
    key: 'expertsField',
    category: 'experts',
    metaTitle: 'Edugram for Field Experts - Share Your Professional Expertise',
    metaDescription:
      'Industry experts, share your specialized knowledge with the world. Create professional courses, establish thought leadership, and monetize your expertise on Edugram.',
    keywords: [
      'industry expert',
      'professional expertise',
      'expert courses',
      'thought leadership',
      'professional development',
      'specialist training',
    ],
  },
  {
    slug: 'schools-universities',
    key: 'schoolsUniversities',
    category: 'experts',
    metaTitle: 'Edugram for Schools & Universities - Institutional Learning Platform',
    metaDescription:
      'Enterprise-grade online learning for educational institutions. Schools and universities can create, manage, and deliver courses at scale with Edugram.',
    keywords: [
      'school learning platform',
      'university online courses',
      'institutional LMS',
      'educational institution platform',
      'school online learning',
      'university course management',
    ],
  },
]

export function getUseCaseSlugs(): string[] {
  return USE_CASES.map((useCase) => useCase.slug)
}

export function getUseCaseBySlug(slug: string): UseCase | undefined {
  return USE_CASES.find((useCase) => useCase.slug === slug)
}
